module.exports = __webpack_public_path__ + "static/media/empty.a42964cf.svg";